var rewardRedeemHTMLTemplate = `
<html>
   <head>
      <meta charset="UTF-8">
      <meta name = "viewport" content = "initial-scale = 1.0, user-scalable = no, width = device-width"/>
      <style type="text/css">
         body {
         font-size: 14px;
         color: #B0B0B0;
         }
         hr {
         padding: 0;
         margin: 0;
         margin-top: 3px;
         margin-bottom: 3px;
         }
         .sub-header {
         padding: 0;
         margin: 0;
         padding-top: 5px;
         padding-bottom: 5px;
         }
         .text {
         color: #3d3d3d;
         }
         .redeem-date {
         color: #3d3d3d;
         margin-top: 3px;
         margin-bottom: 5px;
         }
         .header {
         position: relative;
         display: block;
         padding-top: 10px;
         width: 100%;
         height: 100%;
         margin-bottom: 10px;
         }
         .headerImg {
         width: 100%;
         height: 350px;
         }
         .headerImg2 {
            width: 60%;
            display: inline-block;
            vertical-align: top;
            margin-top: 1px;
         }
         .img-container {
         width: 500px;
         height: 350px;
         display: inline-block;
         margin-bottom: 5px;
         margin-right: 20px;
         background-color: #000000;
         }
         .headertitle{
            font-size: 26px;
            font-weight: bolder;
            color: #000000;
         }
         .headerDescription{
            font-size: 15px;
            margin-top: 5px;
            margin-bottom: 10px;
            font-weight: normal;
            color: #3d3d3d;
         }
         .contactDiv {
            margin-bottom: 5px;
         }
         .contactMargin {
            margin-left: 3px;
         }
         .addressClass {
            width: 95%;
            margin-top: 5px;
            display: inline-block;
         }
         .emptyrow {
            margin-top: 10px;
         }
         .center {
         color: #fff;
         position: absolute;
         width: 500px;
         top:170px;
         text-align: center;
         }
         .reference-code {
         font-size: 26px;
         }
         .bottom {
         position: absolute;
         width: 100%;
         bottom: -10px;
         }
         .addressImage {
            width: 20px;
            margin-top: 5px;
            vertical-align: top;
            display: inline-block;
         }
         .bottom span {
         display: block;
         min-width: 100%;
         color: white;
         background: rgba(0, 0, 0, 0.4);
         }
         .bottom span p {
         margin-bottom: 0;
         padding: 10px;
         font-size: 18px;
         }
         .bottom span label {
         font-weight: normal;
         font-size: 12px;
         }
         .img-container img {
         opacity: 0.6;
         }
         .icon {
         width: 16px;
         height: 16px;
         vertical-align: middle;
         }
         .descriptionDiv{
            margin-top: 5px;
         }
         .label-content {
         text-align: left;
         // word-break: break-all;
         padding-bottom: 10px;
         }
         .contact-row {
         height: auto;
         }
         .headerMain{
            padding-left: 10px;
         }
         .content-about {
         align-content: stretch;
         // word-break: break-all;
         }
         #map {
         height: 300px;  /* The height is 400 pixels */
         width: 100%;  /* The width is the width of the web page */
         }
         ul {
            padding-left: 20px;
         }
      </style>
      <title>MHC Rewards</title>
   </head>
   <body>
      <!-- Page content -->
      <div id="container" class="headerMain">
         <div class="header">
            <div class="img-container">
               <img class="headerImg" src="%%Header-Image%%">
            </div>
            <div class="center">
               <span>
                  <strong class="reference-code">CODE %%Redeem-Reference%%</strong>
                  <p>Offered by Rewardz</p>
               </span>
            </div>
            <div class="headerImg2" >
               <div class="headerImg3">
                    <div class="headertitle">%%Header-Title%%</div>
                    <div class="headerDescription">%%Header-Description%%</div>
                    <div class="col-xs-12 ">
                     <h4>ADDRESS</h4>
               </div>
               <div class="addressDiv">
                  <div class="addressImage">
                     <img class="icon" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAABS2lUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxNDAgNzkuMTYwNDUxLCAyMDE3LzA1LzA2LTAxOjA4OjIxICAgICAgICAiPgogPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIi8+CiA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgo8P3hwYWNrZXQgZW5kPSJyIj8+LUNEtwAAA8xJREFUaIG92kmIHkUUB/DfZMaDSlBRiHrQeIqBiCIhuOAKGhVFRMcxorgkBy+KuI6CeFFHDy7kouJFMQxO3EAdV8xBMbgMKBFxHwUnCGoUjMZ94qG+gY+xq7uquj//0Ifu+td779/V/brqVQ+pwdTUVF1zDMuxCifiCByEvfEXvsfn2IoP8D525xgfGxurvD5SEmkE5+BanFrDWSkIXN87/xoPYRLftHG+pE3nHi7BJ3hOvYgqLMfdmMUE9i8Noo2QA/AMHseKFnYIT8Y4PsJZJQZKhZyAD3FeYf8YlmEa9+R2LHlHTsGWDH7/yzyU2Ocm7IlrUp3kjsgq+SJ2Y753LJyn4Grcm+ooR8gw3mzgLA50qOdjuHcMSR8VuA6jKcQcIZPYN4PfFSaxTxMpVcixuDCBl3vHUzCCB5tIqUIaDQ0Y63B0HSEla52GIwsDeBbb8JswUofhdOFDmItxNU9FipANBU6ncDs+rWgbFjLS/Zk2R7EffqpqbHq0lopnjVgancBFqkXAP3gAa/B3hl04OdbQJGSl6pc35mwatzbYXMB7OLfi+lCN/WgqbhKyOnK9Kjv9KS2z9eNFvJbBj76rpUKqMI1dGfwFVI1gLIVHv2NNQg5NDocnMrj9mMFcIndprKFJyF7J4fBlBncxfkjkReNtEjKfHkurL3rr2UCTkO8ybB3eIo5libzfYw1NQmbSY3FxBrcfJ+HARG7lx5BmIVuTw2EtDs7gL2Aig/tZrKFJyLYMJ0uwOYMPlwkz637ULb6eqnNehx14PT0ux+ORRO75eDTDNrwaa0iZxm/KdLZBKLwdF2k/BBvV3F3VWewdbI91SJn9Pi9UCfdI4C7gKLwlTBxfEEZ2BMfgDPU3MJaKH65zmCJkhzBbvTGBuxgrtK95EbJV3QgmrxA3to8lipSqyl3YWUdIFTInVBS7RoqInTpcs8PNGdxUpBQr7sSvTYZyhHyL+zL4XeBnieXT3Erj9T3j/xeuTCWWFLFLihEleANPp5JLhDyJtwv65SJrElq6rTCqugLSFW5R8xWvQqmQOVxR2LcJM8IuVhba7Fhtwist+ldhXlgOZKPtHuIFun3ELsWPJR3bCvlF4R2swGPCFkIRutjV3YLbWtqYxeVtDHQhBO4QpuulaD2qXQkh/DCQlTJ7WIsv2jrvUgjhr4acWti4muVrDroWMouzE7mbFeynx9C1EHgJVzVw3kX13zGFGIQQwvo6tke+XXgEO8WghMAN/luh3yX8/vFH184GKYSwG/ty3/lqfDUIR4MWAmcKYtbh40E5+RcTzqAcIUObmwAAAABJRU5ErkJggg==">
                  </div>
                  <div class="text label-content addressClass">
                     %%Content-Address%%
                  </div>
               </div>
               <div class="contactDiv">
                  <h4>CONTACT</h4>
               </div>
               <div class="col-xs-12 row contact-row">
                  <div class="col-xs-4 col-sm-4 text">
                     <img class="icon" src="data:image/png;base64,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">
                     Phone
                  </div>
               </div>
               <div class="col-xs-12">
                  <div class="label-content contactMargin">
                     <a href="%%Call-Phone%%">%%Content-Phone%%</a>
                  </div>
               </div>
               <div class="col-xs-12 row contact-row">
                  <div class="col-xs-4 col-sm-4 text">
                     <img class="icon" src="data:image/png;base64,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">
                     Email
                  </div>
               </div>
               <div class="col-xs-12">
                  <div class="label-content contactMargin">
                     <a href="%%Mail-To%%" target="_top">%%Content-Email%%</a>
                  </div>
               </div>
               <div class="col-xs-12 row contact-row">
                  <div class="col-xs-4 col-sm-4 text">
                     <img class="icon" src="data:image/png;base64,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">
                     Website
                  </div>
               </div>
               <div class="col-xs-12">
                  <div class="label-content contactMargin">
                     <a href="%%Content-Website%%">%%Content-Website%%</a>
                  </div>
               </div>
            </div>
         </div>
         
         <div class="col-xs-12">
            <div class="row">
               <div class="descriptionDiv">
                  <div class="content-about text">
                     %%Redeem-Description%%
                  </div>
               </div>
            </div>
            %%Show-Attachment-Start%%
            <div class="emptyrow">
               <div class="contactDiv">
                  <h4>ATTACHMENT</h4>
               </div>
               <div class="col-xs-12">
                  <div class="text label-content">
                     <a href="%%Content-Attachment%%" target="_blank">%%Content-Attachment%%</a>
                  </div>
               </div>
            </div>
            %%Show-Attachment-End%%
            <div class="row">
               <div class="col-xs-12 redeem-date">
                  <strong>Redeemed on %%Redeemed-Date%%</strong>
               </div>
            </div>
            <div class="row">
               %%Show-Map-Start%%
               <div id="map"></div>
               %%Show-Map-End%%
            </div>
         </div>
         &nbsp;<br /><br />
         <!-- End Page Content -->
      </div>
      <script src="https://mymhcapp.mhc.asia/static/vouchers/js/bootstrap.min.js"></script>
      %%Show-Map-Start%%
      <script>
         function initMap() {
           var coordinates = {lat: %%Coordinates-Lat%%, lng: %%Coordinates-Long%%};
           var map = new google.maps.Map(
               document.getElementById('map'), {zoom: 17, center: coordinates, streetViewControl: false});
           var marker = new google.maps.Marker({position: coordinates, map: map});
         }
      </script>
      <script async defer
         src="https://maps.googleapis.com/maps/api/js?key=AIzaSyD45KqNfcdZxB4s7Q59d2wTfWtVC4M518U&callback=initMap"></script>
      %%Show-Map-End%%
   </body>
</html>
`;

export default rewardRedeemHTMLTemplate;
